export default "__VITE_ASSET__7mzkw$sL__"